<div [@scaleIn] *ngIf="visible" class="dialog">
    <div class="row container">
        <div class="col-md-8">
            <div class="content">
                <img src="../../../assets/images/logo_white.png" width="100px"
                    style="display:inline; margin-right: 15px">
            </div>
        </div>

        <div class="col-md-4 parDiv">
            <p>call us: +27 (0)62 263 1710</p>
        </div>
    </div>
    <hr color="white" class="rounded" size="8" width="100%">
    <!-- <img class="img-fluid header" src="" /> -->
    <h2>Register as Property Owner</h2>

    <form class="row" [formGroup]="registerForm" (ngSubmit)="submit()">

        <div class="form-group col-sm-12">
            <label for="firstname">First Name </label>
            <input type="text" class="form-control" formControlName="firstname" id="firstname" placeholder="Firstname">
        </div>

        <div class="form-group col-sm-12">
            <label for="lastname">Last Name </label>
            <input type="text" class="form-control" formControlName="lastname" id="lastname" placeholder="Lastname">
        </div>

        <div class="form-group col-sm-12">
            <label for="email">Email Address </label>
            <input type="email" class="form-control" formControlName="email" id="email" aria-describedby="emailHelp"
                placeholder="Enter email">
        </div>

        <div class="form-group col-sm-12">
            <label for="Cellphone">Cellphone</label>
            <input type="text" class="form-control" formControlName="cellphone" id="cellphone" placeholder="Cellphone">
        </div>

        <div class="form-group col-sm-12">
            <label for="Password">Password (Must contain character, number and letter)</label>
            <input type="password" class="form-control" formControlName="pwd" id="pwd" placeholder="Password">
        </div>

        <div class="form-group col-sm-12">
            <label for="Confirm Password">Confirm Password</label>
            <input type="password" class="form-control" formControlName="confPwd" id="confPwd"
                placeholder="Confirm Password"><br>

            <!-- Password confirmation Error Msg -->
            <div class="alert alert-danger" role="alert" *ngIf="noMatchPwd">
                Please Match the Passwords !
            </div>
        </div>

        <div class="form-group col-sm-12" *ngIf="showConfFields">
            <label for="Code">Verification Code (code has been sent into your email)</label>
            <input type="text" class="form-control" formControlName="code" id="code" placeholder="code"><br>
            <button *ngIf="showConfFields" (click)="confirmSignUp()" class="btn btn-primary m-b-1">Confirm</button>

        </div>

        <div class="form-group col-sm-12">

            <div class="row d-flex justify-content-center" *ngIf="isLoading">
                <img class="loader" src="../../assets/images/loader.gif" width="60px" alt="">
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <button type="submit" class="btn btn-primary m-b-1">Register</button>
                </div>
                <div class="col-sm-6">
                    <button (click)="close()" class="btn btn-primary m-b-1 dialog__close-btn">CLOSE</button>
                </div>
            </div>
        </div>

    </form>

    <div class="form-group col-sm-12">
        <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
            {{errorMessage}}
        </div>
        <div class="alert alert-success" role="alert" *ngIf="success">
            <p>Please confirm registration with code sent to your email.</p>
        </div>
        <div class="alert alert-success" role="alert" *ngIf="code_success">
            <p>You have successfully registered as property Owner. A confirmation email has been sent to you.</p>
        </div>
    </div>
    <!-- <div class="col-sm-12">
        <div class="col-sm-6">
            <button (click)="close()" class="btn btn-danger">CLOSE</button>
        </div>
    </div> -->
</div>